import Categroy from "layout/Category";
import Layout from "layout/Layout";
import React, { useState, useEffect } from "react";
import {
  home_1,
  home_2,
  home_3,
  home_1m,
  home_2m,
  home_3m,
  logo_symbol,
  medmall_logo,
} from "utils/linkData";
import { requestGet, requestPost } from "utils/AxiosApi";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";

import { API_SERVER_URL } from "utils/config";
import HeaderSearch from "./HeaderSearch";

const leftArrow = "svg/chevron_left_arrow_icon.svg";
const rightArrow = "svg/chevron_right_arrow_icon.svg";

function Arrow(props: any) {
  let className = props.type === "next" ? "nextArrowHome" : "prevArrowHome";
  className += " arrow";
  const char =
    props.type === "next" ? (
      <img alt="arrow" src={rightArrow} style={{ width: "30px" }}></img>
    ) : (
      <img alt="arrow" src={leftArrow} style={{ width: "30px" }}></img>
    );
  return (
    <span className={className} onClick={props.onClick}>
      {char}
    </span>
  );
}
const Home = () => {
  let history = useNavigate();
  const [userSts, setUserSts] = useState(false);

  const [banner1, setBanner1] = useState("");
  const [banner2, setBanner2] = useState("");
  const [banner3, setBanner3] = useState("");

  const [contents, setContents] = useState("");
  const [list, setList] = useState<
    [{ img: ""; kindNm: ""; title: ""; salePrice: 0; tagMsg: "" }] | null
  >(null);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    nextArrow: <Arrow type="next" />,
    prevArrow: <Arrow type="prev" />,
  };

  const onSearchGoods = () => {
    history("/goods?contents=" + contents);
  };

  const authChk = async () => {
    let data = await requestPost("/api/auth", {});

    let auth = data.split(":")[1];
    if ("true" !== auth) {
      setUserSts(false);
    } else {
      setUserSts(true);
    }
  };

  const getGoodsList = async () => {
    let data = await requestGet("/api/goods/list", {
      contents: "",
      kind: "HOT",
      page: 0,
      pageSize: 8,
    });
    let d = data.list;
    let dataList = d.content;
    setList(dataList);
  };

  const selectedItem = (itemNum: any) => {
    history("/detail?itemNum=" + itemNum);
  };

  const textLineBreak = (text: string) => {
    let arr: string[] = [];
    arr = text.split("@");
    if (arr[1] !== undefined) {
      let arr2 = arr.slice(1, arr.length);
      return (
        <span className="title">
          {arr[0]}
          <br></br>
          {arr2.map((char: any) => char)}
        </span>
      );
    } else {
      return (
        <span
          className="title"
          style={{
            position: "absolute",
            width: "250px",
            transform: "translate(-50%, 50%)",
          }}
        >
          {text}
        </span>
      );
    }
  };
  const tagLineBreak = (text: string) => {
    let arr = text.split("#");
    return arr.map((char: any, index: any) => (
      <div key={index}>
        <span className="tag">#{char}</span>
        <br></br>
      </div>
    ));
  };

  const priceToString = (item: any, p: any) => {
    let price = item.salePrice;
    if (p === "price") {
      price = item.price;
    }
    let num = price;
    if (item.kindNm === "건강기능식품" || item.kindNm === "건강(기능)식품") {
      let calculation = price;
      num = calculation.toFixed();
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    authChk();
    getGoodsList();
  }, []);

  const handleResize = () => {
    if (window.innerWidth < 550) {
      setBanner1(home_1m);
      setBanner2(home_2m);
      setBanner3(home_3m);
    } else {
      setBanner1(home_1);
      setBanner2(home_2);
      setBanner3(home_3);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Layout>
      <HeaderSearch
        medmall_logo={medmall_logo}
        contents={contents}
        setContents={setContents}
        onSearchGoods={onSearchGoods}
      ></HeaderSearch>

      <div className="div-left-search-m">
        <input placeholder="Search"></input>
        <img src="/svg/search.svg" alt="search" />
      </div>
      <Categroy></Categroy>
      <div className="div-home-slider">
        <div>
          <Slider {...settings}>
            <div>
              <div
                className="div-home-slider-item"
                style={{ backgroundColor: "#FFF", cursor: "pointer" }}
                onClick={() => history("/detail?itemNum=1")}
              >
                <img src={banner1} alt="home_banner"></img>
              </div>
            </div>
            <div>
              <div
                className="div-home-slider-item"
                style={{ backgroundColor: "#FFF", cursor: "pointer" }}
                onClick={() => history("/detail?itemNum=21")}
              >
                <img src={banner2} alt="home_banner"></img>
              </div>
            </div>
            <div>
              <div
                className="div-home-slider-item"
                style={{ backgroundColor: "#FFF", cursor: "pointer" }}
                onClick={() => history("/goods?cateCd=S003")}
              >
                <img src={banner3} alt="home_banner"></img>
              </div>
            </div>
          </Slider>
        </div>
      </div>
      <div>
        <div className="web-template-list-form" style={{ marginLeft: "10px" }}>
          <img
            className="img-logo-symbol"
            src={logo_symbol}
            alt="logo_symbol"
          ></img>
          <span className="span-title-popular">인기&추천 상품</span>
        </div>
        {/* item */}
        <div className="img-goods-list">
          <ul>
            {list !== null && list.length > 0 ? (
              list.map((item: any, index: any) => (
                <li onClick={() => selectedItem(item.seq)} key={index}>
                  <div className="item">
                    <div className="div-goods-kind">
                      <div>
                        <span>
                          {item.kindNm === "건강기능식품(단품)"
                            ? "건강기능식품"
                            : item.kindNm}
                        </span>
                      </div>
                    </div>
                    <div className="img-goods-img border-solid-gray">
                      <img
                        src={
                          API_SERVER_URL +
                          "/api/goods/show?kind=T&filename=" +
                          item.img
                        }
                        alt="img"
                        style={{ display: "inline" }}
                      ></img>
                    </div>
                    <div
                      className="div-goods-title margin-bottom-10"
                      style={{
                        position: "relative",
                        marginTop: "5px",
                        height: "47px",
                      }}
                    >
                      <div>{textLineBreak(item.title)}</div>
                    </div>
                    <div className="div-goods-title">
                      {item.tagMsg && tagLineBreak(item.tagMsg)}
                    </div>
                    <div className="div-goods-price">
                      <div>
                        <div style={{ float: "left" }}>
                          <span className="price-label">소비자가</span>
                        </div>
                        <div style={{ float: "right" }}>
                          <span
                            className="price"
                            style={{ textDecoration: "line-through" }}
                          >
                            {priceToString(item, "price")}
                          </span>
                          <span className="price-unit">원/개</span>
                        </div>
                      </div>
                    </div>
                    <div className="div-goods-price">
                      <div>
                        <div style={{ float: "left" }}>
                          <span className="price-label">최저가격</span>
                        </div>
                        <div style={{ float: "right" }}>
                          <span className="price salePriceRate">
                            (
                            {item.discountRate !== 0 ? item.discountRate : "00"}
                            %↓)
                          </span>
                          <span className="price">
                            {priceToString(item, "salePrice")}
                          </span>
                          <span className="price-unit">원/개</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <div>
                {
                  <div>
                    <br></br>
                    <br></br>
                    <span>등록된 상품이 없습니다.</span>
                    <br></br>
                    <br></br>
                  </div>
                }
              </div>
            )}
          </ul>
          <br></br>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
